import { render, staticRenderFns } from "./SubmittedParty.vue?vue&type=template&id=1f89f368&scoped=true"
import script from "./SubmittedParty.vue?vue&type=script&lang=js"
export * from "./SubmittedParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f89f368",
  null
  
)

export default component.exports